// extracted by mini-css-extract-plugin
export var messageSideLeft = "_q4-1";
export var stateContainer = "_q4-0";